module.exports = __webpack_public_path__ + "static/media/bureau_light.20440098.png";